//@ts-nocheck
import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import { useAlert } from 'react-alert';
import { getStorageHistory } from 'services/apiRequests/storage.api';
import StorageHistoryList from './StorageHistoryList';
import Pagination from 'components/pagination';

const StorageHistoryTab = () => {
  const alert = useAlert();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 20,
    totalPages: 1,
    totalItems: 0,
  });
  const [filters, setFilters] = useState({
    type: '',
    storageItemName: '',
    startDate: '',
    endDate: '',
  });

  const fetchHistory = async (page = 1, currentFilters = filters) => {
    setLoading(true);
    try {
      const params = {
        page,
        limit: pagination.limit,
        ...currentFilters,
      };

      // Remove empty filters
      Object.keys(params).forEach((key) => {
        if (!params[key]) {
          delete params[key];
        }
      });

      const data = await getStorageHistory(params);
      setHistory(data.history || []);
      setPagination({
        page: data.pagination?.page || 1,
        limit: data.pagination?.limit || 20,
        totalPages: data.pagination?.totalPages || 1,
        totalItems: data.pagination?.totalItems || 0,
      });
    } catch (error) {
      console.error('Błąd pobierania historii:', error);
      alert.error('Błąd podczas pobierania historii magazynu');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchHistory();
  }, []);

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
    fetchHistory(newPage);
  };
  const handleFilterChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFilterSubmit = (e) => {
    e.preventDefault();
    fetchHistory(1, filters);
  };

  const handleClearFilters = () => {
    const clearedFilters = {
      type: '',
      storageItemName: '',
      startDate: '',
      endDate: '',
    };
    setFilters(clearedFilters);
    fetchHistory(1, clearedFilters);
  };

  return (
    <Container fluid className="py-3">
      <Row>
        <Col>
          <Card>
            <Card.Header>
              <h5 className="mb-0">Historia magazynu</h5>
            </Card.Header>
            <Card.Body>
              {/* Filtry */}
              <Form onSubmit={handleFilterSubmit} className="mb-4">
                <Row>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Typ operacji</Form.Label>
                      <Form.Select
                        value={filters.type}
                        onChange={(e) =>
                          handleFilterChange('type', e.target.value)
                        }
                      >
                        <option value="">Wszystkie</option>
                        <option value="dodano">Dodano</option>
                        <option value="pobrano">Pobrano</option>
                        <option value="zmiana ręczna">
                          Zmiana ręczna
                        </option>
                      </Form.Select>
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <Form.Label>Nazwa produktu</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Szukaj po nazwie..."
                        value={filters.storageItemName}
                        onChange={(e) =>
                          handleFilterChange(
                            'storageItemName',
                            e.target.value,
                          )
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Data od</Form.Label>
                      <Form.Control
                        type="date"
                        value={filters.startDate}
                        onChange={(e) =>
                          handleFilterChange('startDate', e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2}>
                    <Form.Group>
                      <Form.Label>Data do</Form.Label>
                      <Form.Control
                        type="date"
                        value={filters.endDate}
                        onChange={(e) =>
                          handleFilterChange('endDate', e.target.value)
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={2} className="d-flex align-items-end">
                    <Button
                      type="submit"
                      variant="primary"
                      className="me-2"
                    >
                      Filtruj
                    </Button>
                    <Button
                      type="button"
                      variant="outline-secondary"
                      onClick={handleClearFilters}
                    >
                      Wyczyść
                    </Button>
                  </Col>
                </Row>
              </Form>

              {/* Informacje o wynikach */}
              <div className="d-flex justify-content-between align-items-center mb-3">
                <div>
                  <small className="text-muted">
                    Znaleziono {pagination.totalItems} wpisów
                    {pagination.totalItems > 0 && (
                      <span>
                        {' '}
                        (strona {pagination.page} z {pagination.totalPages}
                        )
                      </span>
                    )}
                  </small>
                </div>
                <div>
                  <small className="text-muted">
                    Wyświetlane: {pagination.limit} na stronę
                  </small>
                </div>
              </div>

              {/* Lista historii */}
              <StorageHistoryList items={history} loading={loading} />

              {/* Paginacja */}
              {pagination.totalPages > 1 && (
                <div className="d-flex justify-content-center mt-4">
                  <Pagination
                    currentPage={pagination.page}
                    totalPages={pagination.totalPages}
                    totalItems={pagination.totalItems}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default StorageHistoryTab;
